import {
    Component,
    OnInit,
    HostListener,
    AfterViewInit,
    ViewChild,
    ElementRef,
    OnDestroy, AfterViewChecked,
} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ApplyFormService} from '../../../shared/services/apply-form.service';
import {AlertService} from '../../../shared/services/alert.service';
import {BannerService} from '../../../shared/services/banner.service';
import {environment} from '../../../../environments/environment';
import {GalleryService} from '../../../shared/services/gallery.service';
import {ExternalCourseService} from '../../../shared/services/external-course.service';

declare var bootstrap: any;
declare var $: any;
declare var instgrm: any;
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {

    constructor(private router: Router,
                private formBuilder: FormBuilder,
                private applyFormService: ApplyFormService,
                private alertService: AlertService,
                private bannerService: BannerService,
                private galleryService: GalleryService,
                private externalCourse: ExternalCourseService) {
        setInterval(() => {
            this.currentIndex = (this.currentIndex + 1) % this.images.length;
            this.currentMediumScreenIndex = (this.currentMediumScreenIndex + 1) % this.mediumScreenBanner.length;
            this.currentMobileIndex = (this.currentMobileIndex + 1) % this.mobileImages.length;
            this.currentEventsImageIndex = (this.currentEventsImageIndex + 1) % this.eventCarouselImages.length;
        }, 4000);
    }

    formSubmitted = false;
    pcbMappings = [];
    selectedEvent: any = null;
    filteredMappingCourses: any  [];
    bannerHeight = '80vh';
    filteredBranches: any = [];
    programs = [];
    courses = [];
    branches = [];
    groupedTestimonials: any[][] = [];
    mainCarouselIndex: any = 0;
    currentImageIndex: number | null = null;
    eventsCarouselIndex: any = 0;
    carouselIndex: any = 0;
    selectedImpactStat: any = 'programmes';
    programmes = ['Engineering', 'Management', 'Science'];
    specializations = ['B.Tech', 'MBA', 'M.Sc'];
    selectedForm: 'new' | 'existing' = 'new';
    activeTab: any = 'faculties';
    showCourseDropdown = false;
    showBranchDropdown = false;
    private processed = false;

    testimonials = [
        {
            name: 'Pallavi Chauhan',
            course: 'M.sc. - Physics',
            designation: 'J&K Bank',
            image: 'assets/img/home-page-testimonials/pallavi-chauhan.webp',
            feedback: `ARNI University provides an excellent platform to those who have an interest in
                                    research and technology. The professors are well-mannered and talented, ensure
                                    student growth. The laboratory is equipped with all the necessary equipments. The
                                    emphasis on research ethics and
                                    innovation has given me the confidence to pursue my dream of contributing to
                                    physical advancements.`,
        },
        {
            name: 'Punchok Lamo',
            course: 'M.Sc. - Physics',
            designation: 'Govt. Teacher',
            image: 'assets/img/home-page-testimonials/punchok-lamo.webp',
            feedback: `Throughout my learning journey at ARNI University, I was always encouraged to focus
                                    on practical learning. The faculty organized science fairs, conducted open
                                    experiment classes, analyzed our data, and helped to develop critical thinking
                                    skills. Lectures from industry experts keep us updated with real-world scenarios and
                                    boost our confidence.`,
        },
        {
            name: 'Vinit Gupta',
            course: 'Diploma in Pharmacy',
            designation: 'Garg Pharma',
            image: 'assets/img/home-page-testimonials/vinit-gupta.webp',
            feedback: `I was a little nervous and worried about the course curriculum when I joined this
                                    program. But the best student support and world-class faculty made everything easy
                                    and synchronized for me. The faculty members are absolutely knowledgeable and always
                                    ready to help whenever required. Apart from theoretical learning, they focus on
                                    applying what we learn. I had a great time here!`,
        },
        {
            name: 'Geetika Katoch',
            course: 'MBA in HR',
            designation: 'Hitech Engineering Industry, Malot',
            image: 'assets/img/home-page-testimonials/geetika-katoch.webp',
            feedback: `  The professors at ARNI are not just teachers; they are mentors who guide you at
                                    every step. Their real-world experience and industry insights make learning so much
                                    more engaging. Thanks to their career counseling, I was able to choose the right
                                    specialization for my MBA!`,
        },
        {
            name: 'Harshal Singh Thakur',
            course: 'B. Tech CSE',
            designation: 'Genpact Bengaluru',
            image: 'assets/img/home-page-testimonials/harshal-singh.webp',
            feedback: `Apart from the studies and their positive behavior towards students, the one thing I loved about this university is its placement services. They have collaborated with big companies, which helps students to get real-world experience and internships with minimum effort.`,
        },
    ];
    course = {
        name: 'B.Tech.',
        duration: '4 Year',
        level: 'Undergraduate',
        admission: 'SUAT or JEE-Main, Followed by PI'
    };
    department = {
        name: 'Arni School of Engineering & Technology',
        established: 2009,
        tagline: 'CREATING ACHIEVERS IN ENGINEERING'
    };
    dean = {
        name: 'Prof. (Dr.) Neeraj Bhandari',
        designation: 'Dean, Arni School of Engineering & Technology',
        image: 'assets/img/dean-arni.jpeg'
    };
    tabs = [
        'Programme Overview',
        'Eligibility Criteria',
        'Scholarship',
        'Career Path',
        'Programme Fee',
        'Financial Assistance',
        'Frequently Asked Questions (FAQ\'s)'
    ];
    activeTabb = 'Programme Overview';
    overview = {
        description: `The B.Tech programme allows students to gain a practical understanding of different engineering functions and grow through cross-functional relationships.`,
        highlights: [
            'Industry-centric curriculum designed specifically for our students.',
            'Full-time internship or summer exchange for global exposure in 4 countries.',
            'Hands-on learning via labs, assignments, and case studies.',
            'Industrial visits to enhance industry exposure.',
            'Career prospects in diverse sectors like IT, Media, Consultancy, E-commerce etc.'
        ],
        specializations: ['B.Tech Computer Science Engineering (CSE)', 'B.Tech Mechanical Engineering']
    };
    impactStats = {
        programmes: {
            number: '200+',
            title: 'Programs',
            description:
                'From engineering to humanities, hotel management, business, health science, and yoga, ARNI offers a vast range of undergraduate, postgraduate, and doctoral courses to fulfill the educational needs of every student. Our courses are designed under the guidance of industry experts and experienced faculty, ensuring the growth and success of the aspirants.\n',
        },
        students: {
            number: '11000+',
            title: 'Students',
            description:
                'More than 1100 students are enrolled in various programs offered by ARNI University to fulfill their professional goals.',
        },
        countries: {
            number: '120+',
            title: 'Campus',
            description:
                'With a 120+ acre, multidisciplinary, lush, green campus following a breathtaking panoramic vista of the Dhauladhar Mountain Ranges, ARNI Campus is a perfect place to learn in peace under the roof of beautiful surroundings.',
        },
        sports: {
            number: '20+',
            title: 'Sports & Training',
            description:
                'With 20+ sports activities, ARNI University focuses on students\' holistic development in terms of physical and mental health along with academic excellence.',
        },
        faculty: {
            number: '500+',
            title: 'Faculty',
            description:
                'We have a team of 500+ highly passionate and experienced faculty members who provide textbook knowledge and are always eager to mentor students to grow personally & professionally.',
        },
        collaboration: {
            number: '95+',
            title: 'Collaborations',
            description:
                'We have collaborated with 95+ companies and industries that help to create better opportunities for our students and offer them internships to experience real-world challenges.',
        },
    };

    announcements = [
        {
            date: '11 Sept 2025',
            title: 'Announcing ICIT 2025, in Collaboration with ARNI University and INTI University – 11 Sept at INTI',
            color: 'bg-red-500',
            image: 'assets/img/arni-announcements-images/icit-2025.webp',
            link: 'https://icit2025.newinti.edu.my/'
        },
        {
            date: '13 May 2025',
            title: 'We are hiring!',
            color: 'bg-pink-500',
            image: 'assets/img/arni-announcements-images/we-are-hiring.webp',
            link: 'quick-links/announcements'
        },
        {
            date: '02 Apr 2025',
            title: 'Admissions To Phd. Programme',
            color: 'bg-yellow-500',
            image: 'assets/img/arni-announcements-images/phd-programme.webp',
            link: 'quick-links/announcements'
        },
        {
            date: '02 Apr 2025',
            title: 'Scholarship Upto 100%',
            color: 'bg-green-500',
            image: 'assets/img/arni-announcements-images/scholarship.webp',
            link: 'quick-links/announcements'
        },
        {
            date: '02 Apr 2025',
            title: 'Programs Offered',
            color: 'bg-pink-500',
            image: 'assets/img/arni-announcements-images/programs-offered.webp',
            link: 'quick-links/announcements'
        },
        {
            date: '01 Mar 2025',
            title: 'Convocation Registration 2025',
            color: 'bg-red-500',
            image: 'assets/img/whats-happeing-inarni-home-page/whats-happening2.webp',
            link: 'quick-links/announcements'
        },
        {
            date: '17 Feb 2025',
            title: 'International Conference',
            color: 'bg-blue-500',
            image: 'assets/img/arni-announcements-images/international-conference.webp',
            link: 'quick-links/announcements'
        },
        {
            date: '13 Feb 2025',
            title: 'Course Approval(2024-25)',
            color: 'bg-orange-500',
            image: 'assets/img/arni-announcements-images/course-approval.webp',
            link: 'quick-links/announcements'
        },
        {
            date: '07 Feb 2025',
            title: 'Admission Helpline No- 1800-891-8962, 90-1590-9622',
            color: 'bg-purple-500',
            image: 'assets/img/arni-announcements-images/admission-helpline-no..webp',
            link: 'quick-links/announcements'
        },
    ];
    currentAnnouncementPage = 0;
    announcementsPerPage = 3;
    // Testimonial Slider Variables
    testimonialSlideIndex = 0;
    testimonialSlidesCount = 3; // Total number of slides (consider we show 3 cards at a time on desktop)
    mainCarouselImages: string[] = [
        '../../assets/img/Alumnies/alumni1.webp',
        '../../assets/img/Alumnies/alumni2.webp',
    ];
    events = [
        {
            image: 'assets/img/event-calendar/social-responsibility.webp',
            date: '13 July 2025',
            title: 'A True Reflection of Social Responsibility ',
            description: 'In the wake of the recent cloudburst in Sheraj Thunag Mandi, which left many families displaced and devastated, Aarni University stepped forward with compassion and commitment to serve those affected by the disaster.',
            instaLink: 'https://www.instagram.com/reel/DMBF84MSaCz/?igsh=MWR0ZGw1bTh2dDJvZQ==',
        },
        {
            image: 'assets/img/miss-himachal-2025/miss-himachal-event-2025-1.jpg',
            date: '17 April 2025',
            title: 'Miss Himachal 2025',
            description: 'A grand celebration of the beauty, talent, and spirit of the hills! Held on 17th April, Miss Himachal 2025 is proudly supported by ARNI University and costume by its Fashion Designing Department.'
        },
        {
            date: '18 Oct 2022',
            title: 'Convocation Day 2024',
            description: 'A grand celebration of achievements, cherished memories, and new beginnings\n' +
                '                        — presenting the highlights from ARNI University\'s Convocation held on October 18, 2024.',
            image: 'assets/img/whats-happeing-inarni-home-page/whats-happening2.webp'
        },
        {
            date: '15 Sept 2023',
            title: 'International Conference',
            description: 'ARNI University proudly received recognition for its outstanding contribution to the educational sector, highlighting its dedication to academic excellence, innovation, and shaping future leaders.',
            image: 'assets/img/whats-happeing-inarni-home-page/whats-happening3.webp'
        },
     /*   {
            date: '15 Sept 2023',
            title: 'Jagran Achiever Awards',
            description: 'At the Jagran Achiever Awards 2022, ARNI University was honored with the prestigious title of \'Fast Rising & Emerging University in North India,\' recognizing our commitment to excellence.',
            image: 'assets/img/whats-happeing-inarni-home-page/whats-happening4.webp'
        },*/
    ];

    eventsData = [
        {
            image: 'assets/img/home-page-events/event-home-page.jpg',
            date: '20 June 2024',
            title: 'Our Respected Chancellor sir, Meet with Mr.Sudhir Chaudhary (Journalist in DD News)',
        },
        {
            image: 'assets/img/home-page-events/image-1.webp',
            date: '15 Oct 2024',
            title: 'Our Respected Chancellor sir, Honored with a Prestigious House of Lords Appointment',
        },
        {
            image: 'assets/img/home-page-events/image-2.webp',
            date: '22 Oct 2024',
            title: 'Scientific Programme with Peoples at ARNI',
        },
        {
            image: 'assets/img/home-page-events/image-3.webp',
            date: '19 Oct 2024',
            title: 'Two-day Hands-on Learning of Chromatographic Techniques',
        },
        {
            image: 'assets/img/home-page-events/image-4.webp',
            date: '15 Oct 2024',
            title: 'Degree Distribution Ceremony',
        },
    ];
    eventCarouselImages = [
        {
            url: 'assets/img/events/event7.webp',
            title: 'Parivartan 3.0',
            description: 'Parivartan 3.0 at Arni University is a vibrant fest that blends culture, creativity, and innovation. With energetic performances, exciting competitions, and inspiring ideas, it’s a platform for students to showcase their talents and drive transformation.',
        },
        {
            url: 'assets/img/events/event6.webp',
            title: 'Republic Day Celebration at Arni University',
            description: 'Arni University proudly celebrates Republic Day with patriotic spirit and unity. The event honors our Constitution, showcases cultural performances, and inspires students to uphold the values of democracy and nation-building.',
        },
        {
            url: 'assets/img/events/event8.webp',
            title: 'Dilpreet Dhillon Live at Arni University – 2022',
            description: 'Arni University lit up with energy as Punjabi sensation Dilpreet Dhillon took the stage in 2022. With electrifying performances, thumping beats, and unmatched enthusiasm from the crowd, the evening was a celebration of music, youth, and unforgettable memories.',
        },
        {
            url: 'assets/img/events/event9.webp',
            title: 'Parivartan 3.0 - Arni University',
            description: 'The Group Dance performance at Parivartan 3.0 at Arni University was a vibrant display of unity, rhythm, and energy. Teams of talented dancers came together to showcase their passion and creativity through a captivating blend of traditional and contemporary styles, leaving the audience enthralled. ',
        },
        {
            url: 'assets/img/events/event10.webp',
            title: 'Global Industry Partnerships',
            description: 'Benefit from global exposure and hands-on learning opportunities with world-renowned companies...',
        }
    ];

    schools = [
        {
            name: 'Arni School of Agriculture',
            imageUrl: 'assets/img/schools/1.jpg',
            courses: [{name: 'Agriculture', link: '/asa-agriculture'}],
        },
        {
            name: 'Arni School of Allied Health Sciences',
            imageUrl: 'assets/img/schools/2.jpg',
            courses: [
                {name: 'Radiology', link: '/asahs-radiology'},
                {name: 'Operation Theatre Technology', link: '/asahs-ott'},
                {name: 'Anesthesia', link: '/asahs-anesthesia'},
                {name: 'Optometry', link: '/asahs-optometry'},
                {name: 'Medical Laboratory Technology', link: '/asahs-mlt'},
                {name: 'Physiotherapy', link: '/asahs-physiotherapy#!'},
                {
                    name: 'Naturopathy & Yoga Sciences',
                    link: '/asahs-yogasci#!',
                },
            ],
        },
        {
            name: 'Arni School of Art & Humanities',
            imageUrl: 'assets/img/schools/3.jpg',
            courses: [
                {name: 'English', link: '/asah-english#!'},
                {name: 'Education', link: '/asah-education'},
                {name: 'Library Science', link: '/asah-library-science'},
                {
                    name: 'Journalism & Mass Communication',
                    link: '/asah-journalism-and-mass-communication',
                },
                {name: 'Design', link: '/asah-fashion-design'},
                {name: 'Yoga Science', link: '/asah-yoga-science'},
                {
                    name: 'Vocational Courses',
                    link: '/asah-vocational-course#!',
                },
            ],
        },
        {
            name: 'Arni School of Business Management & Commerce',
            imageUrl: 'assets/img/schools/4.jpg',
            courses: [
                {name: 'Business Studies', link: '/asbmc-business-studies'},
                {name: 'Commerce', link: '/asbmc-commerce'},
                {
                    name: 'Hospitality Management',
                    link: '/asbmc-hospitality-management',
                },
            ],
        },
        {
            name: 'Arni School of Education & Sports',
            imageUrl: 'assets/img/schools/5.jpg',
            courses: [{name: 'Sports', link: '/ases-physical-application'}],
        },
        {
            name: 'Arni School of Basic Sciences & Bio-Technology',
            imageUrl: 'assets/img/schools/6.jpg',
            courses: [
                {name: 'Physics', link: '/asbsbt-physical-science'},
                {name: 'Life Sciences', link: '/asbsbt-life-science'},
                {name: 'Chemistry', link: '/asbsbt-chemistry'},
                {name: 'Maths', link: '/asbsbt-maths'},
            ],
        },
        {
            name: 'Arni School of Law',
            imageUrl: 'assets/img/schools/7.jpg',
            courses: [{name: 'Legal Studies', link: '/asl-legal-studies'}],
        },
        {
            name: 'Arni School of Pharmacy',
            imageUrl: 'assets/img/schools/8.jpg',
            courses: [{name: 'Pharmacy', link: '/asp-pharmacy'}],
        },
        {
            name: 'Arni School of Technology',
            imageUrl: 'assets/img/schools/9.jpg',
            courses: [
                {name: 'Civil Engineering', link: '/ast-civil-engineering'},
                {
                    name: 'Mechanical Engineering',
                    link: 'ast-mechanical-engineering',
                },
                {
                    name: 'Computer Science & Engineering',
                    link: 'ast-computer-science-engineering',
                },
                {
                    name: 'Computer Science & Application',
                    link: 'ast-computer-science-application',
                },
                {name: 'ECE & EE', link: 'ast-ece-ee'},
                {name: 'Cyber Security & AI', link: 'ast-cyber-security'},
            ],
        },
    ];
    collaborations = [
        {
            image: 'assets/img/collab/collab_1.png',
            title: 'Campus World',
            description: 'Collaboration with Campus World',
        },
        {
            image: 'assets/img/collab/collab_2.jpg',
            title: 'Media & Entertainment Skills Council',
            description:
                'Collaboration with Media & Entertainment Skills Council',
        },
        {
            image: 'assets/img/collab/collab_3.png',
            title: 'Aspire',
            description: 'Collaboration with Aspire Business School Barcelona',
        },
        {
            image: 'assets/img/collab/collab_4.jpg',
            title: 'CGIA',
            description: 'Collaboration with CGIA Institute',
        },
    ];
    companies = [
        {name: 'Adani Wilmar', logo: 'assets/img/companies/adani_wilmar.png'},
        {name: 'Amar Ujala', logo: 'assets/img/companies/amarujala.png'},
        {name: 'Amazon', logo: 'assets/img/companies/Amazon.png'},
        {name: 'CMC', logo: 'assets/img/companies/cmc-logo_0.png'},
        {name: 'Dish TV', logo: 'assets/img/companies/Dish_TV_2.png'},
        {name: 'Future Group', logo: 'assets/img/companies/FutureGroup.png'},
        {name: 'HCL', logo: 'assets/img/companies/hcl.png'},
        {name: 'ICICI', logo: 'assets/img/companies/icici_securities.png'},
        {name: 'Sleepwell', logo: 'assets/img/companies/sleepwell.png'},
        {name: 'SYNTEL', logo: 'assets/img/companies/syntel2.png'},
        {
            name: 'Tech Mahindra',
            logo: 'assets/img/companies/Tech_Mahindra_New_Logo1.png',
        },
        {name: 'Vodafone', logo: 'assets/img/companies/Vodafone_logo.png'},
        {name: 'Zee TV', logo: 'assets/img/companies/Zee_TV_2011.png'},
        {name: 'Genpact', logo: 'assets/img/companies/zenpact.png'},
        {name: 'Reliance', logo: 'assets/img/companies/amarujala.png'},
    ];
    images: string[] = [];
    defaultImages: string[] = [
        'assets/img/home-page-banners/himalayan-campus.webp',
        'assets/img/home-page-banners/Globally-trusted-university-new.webp',
        'assets/img/home-page-banners/woman-empowerment.webp',
        'assets/img/home-page-banners/new-home-page-image.webp',
        'assets/img/home-page-banners/Step-into-success-with-Arni-University.webp',
        'assets/img/home-page-banners/Awarded-by-Several-Global-Prestigious-Bodies.webp',
        'assets/img/home-page-banners/sudhirChaudhary.webp',
        'assets/img/home-page-banners/Rooted-in-Knowledge-Growing-in-Green-Arni-University.webp',
        'assets/img/home-page-banners/criket.webp',
        'assets/img/home-page-banners/Arni-Home-for-future-Athletes.webp',
        'assets/img/home-page-banners/parivartan-babbu-maan.webp',
        'assets/img/home-page-banners/unforgotable-vibe.webp',
        'assets/img/home-page-banners/campus-celebration.webp',
        'assets/img/home-page-banners/graduate-arni.webp',
    ];
    thousandTwoFourScreenSize: string[] = [
        'assets/img/home-page-banners/1024screenBanner/Himalayan-campus.webp',
        'assets/img/home-page-banners/1024screenBanner/Globally-trusted-university.webp',
        'assets/img/home-page-banners/1024screenBanner/woman-empowerment.webp',
        'assets/img/home-page-banners/1024screenBanner/Step-into-success-with-Arni-University.webp',
        'assets/img/home-page-banners/1024screenBanner/Awarded-by-Several-Global-Prestigious-Bodies.webp',
        'assets/img/home-page-banners/1024screenBanner/Rooted-in-Knowledge-Growing-in-Green-Arni-University.webp',
        'assets/img/home-page-banners/1024screenBanner/Circket.webp',
        'assets/img/home-page-banners/1024screenBanner/Arni-Home-for-future-Athletes.webp',
        'assets/img/home-page-banners/1024screenBanner/13.webp',
        'assets/img/home-page-banners/1024screenBanner/12.webp',
        'assets/img/home-page-banners/1024screenBanner/9.webp',
        'assets/img/home-page-banners/1024screenBanner/2.webp',

    ];
    mediumScreenBanner: string[] = [
        'assets/img/home-page-banners/medium-screen/himalayan-campus.webp',
        'assets/img/home-page-banners/medium-screen/Globally-trusted-university-new.webp',
        'assets/img/home-page-banners/medium-screen/woman-empowerment.webp',
        'assets/img/home-page-banners/medium-screen/new-medium-screen-image.webp',
        'assets/img/home-page-banners/medium-screen/Step-into-success-with-Arni-University.webp',
        'assets/img/home-page-banners/medium-screen/Awarded-by-Several-Global-Prestigious-Bodies.webp',
        'assets/img/home-page-banners/medium-screen/home-page-sudhir-medium-screen-banner.webp',
        'assets/img/home-page-banners/medium-screen/Rooted-in-Knowledge-Growing-in-Green-Arni-University.webp',
        'assets/img/home-page-banners/medium-screen/Circket.webp',
        'assets/img/home-page-banners/medium-screen/Arni-Home-for-future-Athletes.webp',
        'assets/img/home-page-banners/medium-screen/medium-screen-kulwinder.webp',
        'assets/img/home-page-banners/medium-screen/11.webp',
        'assets/img/home-page-banners/medium-screen/12.webp',
        'assets/img/home-page-banners/medium-screen/4.webp',

    ];
    mobileImages: string[] = [
        'assets/img/mobile-banners/himalayan-campus.webp',
        'assets/img/mobile-banners/global-university.webp',
        'assets/img/mobile-banners/women-empowerment.webp',
        'assets/img/mobile-banners/step-into-success.webp',
        'assets/img/mobile-banners/new-image-mobile-home-page.webp',
        'assets/img/mobile-banners/awarded-globally.webp',
        'assets/img/mobile-banners/sudhir-chaudhary-mobile.webp',
        'assets/img/mobile-banners/green-campus.webp',
        'assets/img/mobile-banners/arni-cricket.webp',
        'assets/img/mobile-banners/arni-atheletic.webp',
        'assets/img/mobile-banners/parivartan-mobile-babbu-maan.webp',
        'assets/img/mobile-banners/11.webp',
        'assets/img/mobile-banners/12.webp',
        'assets/img/mobile-banners/graduate-arni.webp',
    ];
    slides = [
        {
            image: 'assets/img/unique-degree/unique-degree1.jpg',
            date: '22',
            month: 'MAR',
            title: 'Parivartan 3.0',
            description:
                'Parivartan 3.0 symbolizes transforming visions into reality, inspiring change, innovation, and progress for a brighter future ahead.',
        },
    ];

    /*   studentLifeImages: string[] = [
           'assets/img/student-life/small-images/student-life1.JPG',
           'assets/img/student-life/small-images/student-life2.JPG',
           'assets/img/student-life/small-images/3.jpg',
           'assets/img/student-life/large-images/1.jpg',
           'assets/img/student-life/large-images/2.jpg',
           'assets/img/student-life/small-images/4.jpg',
           'assets/img/student-life/small-images/student-life3.JPG',
           'assets/img/student-life/small-images/student-life4.JPG',
       ];
   */
    lightboxOpen = false;
    slideInterval: any;
    activeSlideIndex = 0;
    currentIndex = 0;
    currentMediumScreenIndex = 0;
    currentMobileIndex = 0;
    currentEventsImageIndex = 0;
    activeIndex = 0;
    hoveredIndex = -1;
    selectedBranchData: any;
    applyNowForm: FormGroup = new FormGroup({});
    searchForm: FormGroup = new FormGroup({});
    topBanners: any;
    middleBanners: any;
    promotionBanner: any;
    galleryImages: any;
    filteredCourses: any[] = [];
    filteredBranch: any[] = [];
    externalCourses: any;

    protected readonly environment = environment;

    ngOnInit() {
        this.refresh();
        this.updateImages();
        this.adjustBannerHeight();
        // this.getTestimonials();
        this.startImageAutoSlide();
        this.startAutoSlide();
        this.startCampusCarousels();
        this.loadFontIfNeeded();
        this.groupTestimonials();
        // this.getBanners();
        this.getGalleriesPhoto();
        window.addEventListener('resize', () => {
            this.updateImages();
        });
    }

    closeModal() {
        this.selectedEvent = null;
    }

    getBanners() {
        this.topBanners = [];
        this.middleBanners = [];
        this.promotionBanner = [];
        this.bannerService.get({status: 'ACTIVE'}).subscribe(data => {
            if (data && data.data?.length > 0) {
                this.topBanners = data.data
                    ?.filter(banner => banner.banner_type === 'TOP_BANNER')
                    .sort((a, b) => a.position - b.position);
                this.middleBanners = data.data
                    ?.filter(banner => banner.banner_type == 'MIDDLE_BANNER')
                    .sort((a, b) => a.position - b.position);
                this.promotionBanner = data.data?.filter(banner => (banner.banner_type == 'PROMOTION_BANNER'));
            }
        });
    }

    openEventModal(event: any) {
        this.selectedEvent = event;
        this.processed = false;
    }

    getGalleriesPhoto() {
        const params = {
            page: 1,
            perPage: 3
        };
        this.galleryImages = [];
        this.galleryService.get({status: 'ACTIVE'}).subscribe(data => {
            if (data && data.data?.length > 0) {
                // tslint:disable-next-line:prefer-for-of
                for (let i = 0; i < data.data?.length; i++) {
                    if (data.data[i]?.files && data.data[i]?.files?.length > 0) {
                        for (let j = 0; j < data.data[i]?.files.length; j++) {
                            if (data.data[i].files[j].media_type == 'IMAGE') {
                                this.galleryImages.push(data.data[i].files[j]);
                                if (this.galleryImages.length == 3) {
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        });
    }


    updateImages() {
        const screenWidth = window.innerWidth;
        if (screenWidth >= 1024 && screenWidth <= 1100) {
            this.images = this.thousandTwoFourScreenSize;
            this.bannerHeight = '60vh';
        } else {
            this.images = this.defaultImages;
            this.bannerHeight = '80vh';
        }
    }

    adjustBannerHeight() {
        const bannerEl = document.getElementById('banner-images');
        if (bannerEl) {
            this.startAutoSlide();
            this.startImageAutoSlide();
        }
    }

    refresh() {
        this.applyNowForm = this.formBuilder.group({
            name: ['', Validators.required],
            email: ['', Validators.required],
            school_id: ['', Validators.required],
            program_id: ['', Validators.required],
            course_id: ['', Validators.required],
            branch_id: [''],
            selectedCourse: [''],
            selectedBranch: [''],
            contact: ['', Validators.required],
        });
        this.searchForm = this.formBuilder.group({
            program_id: ['12'],
            course_id: ['4'],
            branch_id: ['20'],
        });
        this.getPcb();
    }

    getPcb(): void {
        this.applyFormService.pcb_mapping().subscribe(data => {
            this.pcbMappings = data.data;
            this.programs = data.data;
            // this.filteredMappingCourses = this.programs.filter(
            //     (value, index, self) =>
            //         index === self.findIndex((t) => t.course?.name === value?.course?.name)
            // );
            // Select "Bachelor of Technology"
            // const btechCourse = this.filteredMappingCourses.find(course =>
            //     course.course?.name?.toLowerCase().includes('bachelor of technology')
            // );
            // this.filteredMappingCourses.forEach(courseEntry => {
            //     // Get all entries of this course
            //     const courseBranches = this.pcbMappings.filter(
            //         item => item.course?.id === courseEntry.course?.id
            //     );
            //
            //     // Remove duplicate branches for this course
            //     const uniqueBranches = courseBranches.filter(
            //         (value, index, self) =>
            //             index === self.findIndex(t => t.branch?.name === value?.branch?.name)
            //     );
            //
            //     // Add tuition fee for each unique branch
            //     uniqueBranches.forEach(branch => {
            //         const fees = branch.fees || [];
            //         const feeForSession = fees.find(fee => fee?.session_id == 17);
            //         branch.tuitionfee = parseInt(feeForSession?.tuition_fee) || 0;
            //     });
            //
            //     // Store these branches in a new property inside the course
            //     courseEntry.branches = uniqueBranches;
            // });
            // Patch selected course (B.Tech)
            // if (btechCourse) {
            //     this.searchForm.patchValue({
            //         course_id: btechCourse.course.id
            //     });
            //     // Filter branches for selected B.Tech course
            //     this.filteredBranches = this.pcbMappings.filter(
            //         value => value.course?.id === btechCourse.course.id
            //     );
            //     this.filteredBranches = this.filteredBranches.filter(
            //         (value, index, self) =>
            //             index === self.findIndex(t => t.branch?.name === value?.branch?.name)
            //     );
            //     // Select "Computer Science Engineering"
            //     const cseBranch = this.filteredBranches.find(branch =>
            //         branch.branch?.name?.toLowerCase().includes('computer science')
            //     );
            //     if (cseBranch) {
            //         this.searchForm.patchValue({
            //             branch_id: cseBranch.branch.id
            //         });
            //         this.selectedBranchData = cseBranch;
            //         this.getFilteredBranchData();
            //     } else {
            //         // If CSE branch not found
            //         this.searchForm.patchValue({
            //             branch_id: this.filteredBranches[0]?.branch?.id || null
            //         });
            //     }
            // }
            // For dropdown population
            this.programs = this.programs.filter(
                (value, index, self) =>
                    index === self.findIndex((t) => t.program?.name === value?.program?.name)
            );

            this.getExternalCourses();
        });
    }

    getExternalCourses() {
        this.externalCourses = [];
        this.externalCourse.get({status: 'ACTIVE'}).subscribe(data => {
            if (data && data.data?.length > 0) {
                this.externalCourses = data.data;
                this.getFilteredCourses();
                this.getFilteredBranches();
            }
        });
    }

    goTo(url: string) {
        window.location.href = url;
    }


    generateSchoolLink(): string {
        const schoolName = this.selectedBranchData?.school?.name;
        switch (schoolName) {
            case 'ARNI SCHOOL OF ART & HUMANITES':
                return '/schools/arni-school-of-art-and-humanities';
            case 'ARNI SCHOOL OF BUSINESS MANAGEMENT':
                return '/schools/arni-school-of-business-management-and-commerce';
            case 'ARNI SCHOOL OF LAW':
                return '/schools/arni-school-of-law';
            case 'ARNI SCHOOL OF BASIC SCIENCE':
                return '/schools/arni-school-of-basic-science-and-biotechnology';
            case 'ARNI SCHOOL OF TECHNOLOGY':
                return '/schools/arni-school-of-technology';
            case 'ARNI SCHOOL OF PHARMACY AND PARAMEDICAL STUDIES':
                return '/schools/arni-school-of-pharmacy';
            case 'ARNI SCHOOL OF COMMERCE':
                return '/schools/arni-school-of-commerce';
            case 'ARNI SCHOOL OF PHARMACY':
                return '/schools/arni-school-of-pharmacy';
            case 'ARNI SCHOOL OF HEALTH SCIENCE':
                return '/schools/arni-school-of-allied-health-science';
            case 'ARNI SCHOOL OF COMPUTER SCIENCE':
                return '/schools/arni-school-of-computer-science';
            case 'ARNI SCHOOL OF HOSPITALITY & TOURISM MANAGEMENT':
                return '/schools/arni-school-of-hotel-management-and-tourism';
            default:
                return '#';
        }
    }

    getDeanDetails() {
        const schoolName = this.selectedBranchData?.school?.name;

        switch (schoolName) {
            case 'ARNI SCHOOL OF ART & HUMANITES':
                return {
                    image: 'assets/img/dean-as-per-schools/dr-brijesh-tiwari-arni-school-of-arts-and-humanities.png',
                    name: 'Dr. Brijesh Tiwari',
                    designation: 'Dean – School of Art & Humanities'
                };
            case 'ARNI SCHOOL OF BUSINESS MANAGEMENT':
                return {
                    image: 'assets/img/hods-as-per-schools/dr-irshad-ahmad-sofi-arni-school-of-business-management-and-commerce.png',
                    name: 'Dr. Irshad Ahmad Sofi',
                    designation: 'Hod – School of Business Management'
                };
            case 'ARNI SCHOOL OF LAW':
                return {
                    image: 'assets/img/hods-as-per-schools/dr-sudhir-kumar-pal-arni-school-of-law.png',
                    name: 'Dr. Sudheer Kumar Pal',
                    designation: 'Hod – School of Law'
                };
            case 'ARNI SCHOOL OF BASIC SCIENCE':
                return {
                    image: 'assets/img/pro-vice-chancellor.jpg',
                    name: 'Dr. Manish Kumar Srivastava',
                    designation: 'Pro Vice Chancellor'
                };
            case 'ARNI SCHOOL OF TECHNOLOGY':
                return {
                    image: 'assets/img/dean-as-per-schools/dr-gurvinder-singh-arni-school-of-technology.png',
                    name: 'Dr. Gurvinder Singh',
                    designation: 'Dean – School of Technology'
                    /*  openImage(index: number): void {
                          this.currentImageIndex = index;
                      }

                      closeImage(): void {
                          this.currentImageIndex = null;
                      }*/
                };
            case 'ARNI SCHOOL OF PHARMACY':
                return {
                    image: 'assets/img/dean-as-per-schools/dr-neeraj-bhandari-arni-school-of-pharmacy.png',
                    name: 'Dr. Neeraj Bhandari',
                    designation: 'Dean – School of Pharmacy & Paramedical Studies'
                };
            case 'ARNI SCHOOL OF PHARMACY AND PARAMEDICAL STUDIES':
                return {
                    image: 'assets/img/dean-as-per-schools/dr-neeraj-bhandari-arni-school-of-pharmacy.png',
                    name: 'Dr. Neeraj Bhandari',
                    designation: 'Dean – School of Pharmacy & Paramedical Studies'
                };
            case 'ARNI SCHOOL OF COMMERCE':
                return {
                    image: 'assets/img/pro-vice-chancellor.jpg',
                    name: 'Dr. Manish Kumar Srivastava',
                    designation: 'Pro Vice Chancellor'
                };
            case 'ARNI SCHOOL OF HEALTH SCIENCE':
                return {
                    image: 'assets/img/dean-as-per-schools/dr-tahseen-bilal-rather-arni-school-of-allied-health-sciences.png',
                    name: 'Dr. Tahseen Bilal Rather',
                    designation: 'Hod, School of Allied Health Sciences'
                };
            case 'ARNI SCHOOL OF COMPUTER SCIENCE':
                return {
                    image: 'assets/img/pro-vice-chancellor.jpg',
                    name: 'Dr. Manish Kumar Srivastava',
                    designation: 'Pro Vice Chancellor'
                };
            case 'ARNI SCHOOL OF HOSPITALITY & TOURISM MANAGEMENT':
                return {
                    image: 'assets/img/hods-as-per-schools/deepak-dubey-arni-school-of-hotel-management.png',
                    name: 'Dr. Deepak Dubey',
                    designation: 'Hod – Hospitality & Tourism'
                };
            case 'ARNI SCHOOL OF CERTIFICATIONS':
                return {
                    image: 'assets/img/pro-vice-chancellor.jpg',
                    name: 'Dr. Manish Kumar Srivastava',
                    designation: 'Pro Vice Chancellor'
                };
            case 'ARNI SCHOOL OF YOGA SCIENCE':
                return {
                    image: 'assets/img/pro-vice-chancellor.jpg',
                    name: 'Dr. Manish Kumar Srivastava',
                    designation: 'Pro Vice Chancellor'
                };
            case 'School of Business':
                return {
                    image: 'assets/img/pro-vice-chancellor.jpg',
                    name: 'Dr. Manish Kumar Srivastava',
                    designation: 'Pro Vice Chancellor'
                };
            default:
                return {
                    image: 'assets/img/pro-vice-chancellor.jpg',
                    name: 'Dr. Manish Kumar Srivastava',
                    designation: 'Pro Vice Chancellor'
                };
        }
    }


    @HostListener('window:resize')
    onResize() {
        this.groupTestimonials();
    }

    groupTestimonials(): void {
        const screenWidth = window.innerWidth;
        let perSlide = 1;

        if (screenWidth >= 1024) {
            perSlide = 3; // Large screens
        } else if (screenWidth >= 768) {
            perSlide = 2; // Medium screens
        } else {
            perSlide = 1; // Small screens
        }

        const grouped = [];
        for (let i = 0; i < this.testimonials.length; i += perSlide) {
            grouped.push(this.testimonials.slice(i, i + perSlide));
        }

        this.groupedTestimonials = grouped;

        if (this.testimonialSlideIndex >= this.groupedTestimonials.length) {
            this.testimonialSlideIndex = 0;
        }
    }


    getCourses(): void {
        this.applyNowForm.patchValue({
            course_id: null,
            branch_id: null,
            selectedCourse: null,
            selectedBranch: null
        });
        const program = this.applyNowForm?.value?.program_id;

        this.courses = this.pcbMappings.filter(value => value.program?.id == program);
        this.courses = this.courses.filter(
            (value, index, self) =>
                index ===
                self.findIndex((t) => t.course?.name === value?.course?.name)
        );
        this.filteredCourses = this.courses;
        this.filteredCourses = this.filteredCourses;
        const selectedCourseId = this.applyNowForm.value.course_id;
        const courseSchool = this.pcbMappings.find(
            value => value.course?.id == selectedCourseId
        )?.school;

        if (courseSchool) {
            this.applyNowForm.patchValue({
                school_id: courseSchool.id
            });
        }
    }

    getBranches() {
        const schoolId = this.pcbMappings.filter(value => (value.program?.id == this.applyNowForm.value.program_id) && (value.course?.id == this.applyNowForm.value.course_id))[0].school?.id;
        this.applyNowForm.patchValue({
            school_id: schoolId
        });
        const course = this.applyNowForm?.value?.course_id;
        this.branches = this.pcbMappings.filter(value => value.course?.id == course);
        this.branches = this.branches.filter(
            (value, index, self) =>
                index ===
                self.findIndex((t) => t.branch?.name === value?.branch?.name)
        );
        this.filteredBranch = this.branches;
        this.filteredBranch = this.filteredBranch;
    }

    filterCourses(search: string): void {
        this.filteredBranch = this.branches = null;
        this.filteredCourses = this.courses?.filter(c =>
            c?.course?.name?.toLowerCase().includes(search.toLowerCase())
        );
        this.filteredCourses = this.filteredCourses.slice(0, 10);
    }

    selectCourse(course: any): void {
        // this.applyNowForm.get('course_id')?.setValue(course?.course?.id);  // use formControlName
        this.applyNowForm.patchValue({
            course_id: course?.course?.id,
            selectedCourse: course?.course?.name,
            branch_id: '',
            selectedBranch: '',
        });
        this.filteredCourses = [];
        this.getBranches();
    }

    filterBranch(search: string): void {
        this.filteredBranch = this.branches?.filter(c =>
            c?.branch?.name?.toLowerCase().includes(search.toLowerCase())
        );
    }

    selectBranch(branch: any): void {
        if (branch && branch.branch) {
            this.applyNowForm.patchValue({
                branch_id: branch?.branch?.id,
                selectedBranch: branch?.branch?.name
            });
            this.filteredBranch = [];
        }
    }

    getFilteredCourses() {
        this.externalCourses.forEach(course => {
            if (course.id == this.searchForm.value.program_id) {
                this.filteredMappingCourses = course.courses;
                // this.filteredBranches = course.branches;
            }
        });
    }

    getFilteredBranches() {
        const selectedCourseId = this.searchForm?.value?.course_id;

        this.filteredBranches = this.pcbMappings.filter(
            value => value.course?.id == selectedCourseId
        );

        this.filteredBranches = this.filteredBranches.filter(
            (value, index, self) =>
                index === self.findIndex(
                    t =>
                        (t.branch?.name || 'null') === (value.branch?.name || 'null')
                )
        );

        this.searchForm.patchValue({
            branch_id: this.filteredBranches[0]?.branch?.id || null
        });

        this.selectedBranchData = null;
        this.getFilteredBranchData();
    }


    getFilteredBranchData() {
        const selectedCourseId = this.searchForm?.value?.course_id;
        const selectedBranchId = this.searchForm?.value?.branch_id;
        this.selectedBranchData = this.pcbMappings.find(
            item =>
                item.course?.id == selectedCourseId &&
                ((item.branch?.id || null) == (selectedBranchId || null))
        );
    }

    hideDropdownWithDelay(type: any) {
        // Delay hiding to allow click event on dropdown
        if (type == 'COURSE') {
            setTimeout(() => this.showCourseDropdown = false, 150);
        } else if (type == 'BRANCH') {
            setTimeout(() => this.showBranchDropdown = false, 150);
        }
    }


    submit() {
        /* if (!(this.applyNowForm?.valid)) {
             this.alertService.showErrors('All fields are required!');
             return false;
         }*/
        const params = {
            name: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().name && this.applyNowForm.getRawValue().name,
            email: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().email && this.applyNowForm.getRawValue().email,
            contact: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().contact && this.applyNowForm.getRawValue().contact,
            school_id: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().school_id && this.applyNowForm.getRawValue().school_id,
            program_id: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().program_id && this.applyNowForm.getRawValue().program_id,
            course_id: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().course_id && this.applyNowForm.getRawValue().course_id,
            branch_id: this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().branch_id && this.applyNowForm.getRawValue().branch_id,
        };
        this.applyFormService.add(params).subscribe(data => {
            this.formSubmitted = true;
            this.refresh();
        }, error => {
            if (error && error.error && error.error.errors && error.error.errors.name && error.error.errors.name[0]) {
                this.alertService.showErrors(error.error.errors.name[0]);
            } else if (error && error.error && error.error.errors && error.error.errors.email && error.error.errors.email[0]) {
                this.alertService.showErrors(error.error.errors.email[0]);
            } else if (error && error.error && error.error.errors && error.error.errors.contact && error.error.errors.contact[0]) {
                this.alertService.showErrors(error.error.errors.contact[0]);
            } else if (error && error.error && error.error.errors && error.error.errors.program_id && error.error.errors.program_id[0]) {
                this.alertService.showErrors('Program is Required, Please select a program');
            } else if (error && error.error && error.error.errors && error.error.errors.course_id && error.error.errors.course_id[0]) {
                this.alertService.showErrors('Course is Required, Please select a course');
            } else if (error && error.error && error.error.errors && error.error.errors.branch_id && error.error.errors.branch_id[0]) {
                this.alertService.showErrors('Branch is Required, Please select a branch');
            } else if (error && error.error && error.error.errors && error.error.errors.school_id && error.error.errors.school_id[0]) {
                this.alertService.showErrors('Something went wrong, Please fill again all required fields');
                this.applyNowForm.reset();
            }
        });
    }

    /*  openImage(index: number): void {
          this.currentImageIndex = index;
      }

      closeImage(): void {
          this.currentImageIndex = null;
      }*/

    /*  nextImage(): void {
          if (this.currentImageIndex !== null) {
              this.currentImageIndex =
                  (this.currentImageIndex + 1) % this.studentLifeImages.length;
          }
      }*/

    /*  prevImage(): void {
          if (this.currentImageIndex !== null) {
              this.currentImageIndex =
                  (this.currentImageIndex - 1 + this.studentLifeImages.length) %
                  this.studentLifeImages.length;
          }
      }*/

    /*
        openImage(index: number): void {
            this.currentImageIndex = index;
            this.lightboxOpen = true;
        }

        closeLightbox(): void {
            this.lightboxOpen = false;
        }

        showPreviousImage(): void {
            this.currentImageIndex =
                (this.currentImageIndex - 1 + this.studentLifeImages.length) %
                this.studentLifeImages.length;
        }

        showNextImage(): void {
            this.currentImageIndex =
                (this.currentImageIndex + 1) % this.studentLifeImages.length;
        }
    */


    /*
        openImage(index: number) {
            // this.selectedImage = index;
        }*/

    /* closeImage() {
         // this.selectedImage = null;
     }
 */
    ngAfterViewInit() {
        this.startCarousel();
    }
    ngAfterViewChecked() {
        if (this.selectedEvent?.instaLink && !this.processed) {
            if (window['instgrm']) {
                setTimeout(() => {
                    window['instgrm'].Embeds.process();
                }, 100);
                this.processed = true;
            }
        }
    }
    startCarousel() {
    }

    nextImageSlide() {
        // this.activeIndex = (this.activeIndex + 1) % this.testimonials.length;
    }

    prevImageSlide() {
        // this.activeIndex = (this.activeIndex - 1 + this.testimonials.length) % this.testimonials.length;
    }

    goToSlide(index: number) {
        this.activeSlideIndex = index;
    }

    nextSlide() {
        this.activeSlideIndex =
            (this.activeSlideIndex + 1) % this.slides.length;
    }

    prevSlide() {
        this.activeSlideIndex =
            (this.activeSlideIndex - 1 + this.slides.length) %
            this.slides.length;
    }

    startImageAutoSlide() {
        this.slideInterval = setInterval(() => {
            this.nextSlide();
        }, 6000);
    }

    startAutoSlide() {
        this.slideInterval = setInterval(() => {
            this.nextImageSlide();
        }, 9000);
    }

    stopAutoSlide() {
        clearInterval(this.slideInterval);
    }

    pauseSlideOnHover() {
        this.stopAutoSlide();
        this.startImageAutoSlide();
    }

    resumeSlideOnLeave() {
        this.startAutoSlide();
        this.startImageAutoSlide();
    }

    ngOnDestroy() {
        this.stopAutoSlide();
        this.startImageAutoSlide();
    }

    // Methods for Campus Info Section
    startCampusCarousels() {
        // Main banner carousel interval
        setInterval(() => {
            this.nextMainCarousel();
        }, 5000);

        // Events carousel interval
        setInterval(() => {
            this.nextEventsCarousel();
        }, 4000);
    }

    nextCarousel() {
        this.carouselIndex =
            (this.carouselIndex + 1) % this.mainCarouselImages?.length;
    }

    prevCarousel() {
        this.carouselIndex =
            (this.carouselIndex - 1 + this.mainCarouselImages?.length) %
            this.mainCarouselImages?.length;
    }

    setCarousel(index: number) {
        this.carouselIndex = index;
    }


    nextMainCarousel() {
        this.mainCarouselIndex =
            (this.mainCarouselIndex + 1) % this.middleBanners?.length;
    }

    prevMainCarousel() {
        this.mainCarouselIndex =
            (this.mainCarouselIndex - 1 + this.middleBanners?.length) %
            this.middleBanners?.length;
    }

    setMainCarousel(index: number) {
        this.mainCarouselIndex = index;
    }

    nextEventsCarousel() {
        this.eventsCarouselIndex =
            (this.eventsCarouselIndex + 1) % this.eventsData.length;
    }

    prevEventsCarousel() {
        this.eventsCarouselIndex =
            (this.eventsCarouselIndex - 1 + this.eventsData.length) %
            this.promotionBanner.length;
    }

    setEventsCarousel(index: number) {
        this.eventsCarouselIndex = index;
    }

    // Helper method to ensure Montserrat font is loaded
    loadFontIfNeeded() {
        // Simply add the font link to ensure Montserrat is available
        const fontLink = document.querySelector(
            'link[href*="fonts.googleapis.com/css2?family=Montserrat"]'
        );

        if (!fontLink) {
            // If not loaded, add a link to Google Fonts
            const link = document.createElement('link');
            link.href =
                'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap';
            link.rel = 'stylesheet';
            document.head.appendChild(link);
        }
    }

    // Methods for Impact Section
    setSelectedImpactStat(stat: string) {
        if (this.selectedImpactStat === stat) {
            return;
        } // No change needed

        // Get the impact content container
        const impactContentEl = document.querySelector(
            '.impact-content .fade-in'
        );

        // Add class to trigger fade-out animation
        if (impactContentEl) {
            impactContentEl.classList.remove('fade-in');
            impactContentEl.classList.add('fade-out');

            // After animation completes, update content and fade in
            setTimeout(() => {
                this.selectedImpactStat = stat;

                // Force change detection to update the DOM with new content
                setTimeout(() => {
                    impactContentEl.classList.remove('fade-out');
                    impactContentEl.classList.add('fade-in');
                }, 50);
            }, 300); // Match the duration of fade-out animation
        } else {
            // Fallback if element not found
            this.selectedImpactStat = stat;
        }
    }

    getSelectedImpactStat() {
        return this.impactStats[this.selectedImpactStat];
    }

    // Methods for Featured Section
    setActiveTab(tab: string) {
        this.activeTab = tab;
    }

    // Methods for Announcements Section
    nextAnnouncementPage() {
        const totalPages = Math.ceil(
            this.announcements.length / this.announcementsPerPage
        );
        this.currentAnnouncementPage =
            (this.currentAnnouncementPage + 1) % totalPages;
    }

    prevAnnouncementPage() {
        const totalPages = Math.ceil(
            this.announcements.length / this.announcementsPerPage
        );
        this.currentAnnouncementPage =
            (this.currentAnnouncementPage - 1 + totalPages) % totalPages;
    }

    getCurrentAnnouncements() {
        const start = this.currentAnnouncementPage * this.announcementsPerPage;
        return this.announcements.slice(
            start,
            start + this.announcementsPerPage
        );
    }

    // Methods for Testimonial Slider
    nextTestimonialSlide() {
        this.testimonialSlideIndex =
            (this.testimonialSlideIndex + 1) % this.testimonialSlidesCount;
    }

    prevTestimonialSlide() {
        this.testimonialSlideIndex =
            (this.testimonialSlideIndex - 1 + this.testimonialSlidesCount) %
            this.testimonialSlidesCount;
    }

    setTestimonialSlide(index: number) {
        this.testimonialSlideIndex = index;
    }
}
